import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './context/useAuth';

function Login({ showLogoutButton = true }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      const userCredential = await login(email, password);
      console.log("Login successful", userCredential.user);
      navigate('/');
    } catch (error) {
      console.error("Login failed", error.message);
    }
  };

  return (
    <div>
      {
        user
          ? (showLogoutButton ? <button type="button" onClick={logout}>logout</button> : null)
          : (
            <Form onSubmit={handleLogin} className="d-flex align-items-center gap-2 mb-0">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="form-control form-control-sm"
                required
              />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                className="form-control form-control-sm"
                required
              />
              <button type="submit" className="btn btn-primary btn-sm">login</button>
            </Form>
          )
      }
    </div>
  );
}

export default Login;
